var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B9\\u30BF\\u30C3\\u30D5\\u30FB\\u6559\\u5E2B\\u4E00\\u89A7\\u7DE8\\u96C6-1-1",
    transform: "translate(-230.000000, -1688.000000)",
    fill: "#A5A5A5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(213.000000, 1654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_image",
    transform: "translate(17.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,0 C77.6142375,0 100,22.3857625 100,50 C100,77.6142375 77.6142375,100 50,100 C22.3857625,100 0,77.6142375 0,50 C0,22.3857625 22.3857625,0 50,0 Z M49.8333335,38 C40.888889,38 23,42.9085366 23,51.8331486 L23,51.8331486 L23,56.2954547 L76.666667,56.2954547 L76.666667,51.8331486 C76.666667,42.9085366 58.777778,38 49.8333335,38 Z M50.1666665,9 C43.4344444,9 38,14.4344444 38,21.1666665 C38,27.8988886 43.4344444,33.333333 50.1666665,33.333333 C56.8988886,33.333333 62.333333,27.8988886 62.333333,21.1666665 C62.333333,14.4344444 56.8988886,9 50.1666665,9 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvator);
export default __webpack_public_path__ + "static/media/no-avator.9cee57d0e4090fb139fbbe06b4501c90.svg";
export { ForwardRef as ReactComponent };